export default "__VITE_ASSET__ced2cfb2__"